// extracted by mini-css-extract-plugin
export default {"btop":"_4fd8bdb822 b9017a816f b412685729","icon":"a0e2e9bd66 _877c2dab48","btoppink":"_2acd520a73 _5bb0f64307"};